import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Skeleton } from 'antd';

import fetcher, { loadingStatus } from 'helpers/fetcher';
import { fetchPage } from 'store/slices/pageSlice';
import Icon from 'components/Icon';

const DEFAULT_COMMON_TEXT = `Наша компания "РАЙЯН" - это прежде всего дружный, сплоченный, профессиональный коллектив единомышленников!
Честность, добропорядочность, целеустремленность, ответственность, исполнительность, дисциплинированность, внимательность, пунктуальность, трудолюбие, коммуникабельность и доброжелательность - это ценности людей составляющих компанию.
Именно таких людей мы приглашаем и рады видеть в нашей компании!

Дополнительные условия:
Разнообразное обеденное питание в столовой, медкабинет, комната отдыха, массажное кресло, чай, кофе, шахматы. Два раза в год выездной корпоративный отдых на природе с родственниками.

Телефон для справок: +7 (918) 720-76-34
Email: Rayan07@bk.ru`;

const DEFAULT_VACANCIES = [
	{
		title: 'Ученик обвальщика без опыта (учебный период 2 месяца, с последующим трудоустройством)',
		salary: 'ЗП: на период обучения 40-50 тыс.',
		extra: '',
	},
	{ title: 'Обвальщик мяса с опытом работы', salary: 'ЗП: до 150 тыс.', extra: '' },
	{ title: 'Жиловщица мяса', salary: 'ЗП: от 100 тыс.', extra: '' },
	{ title: 'Водитель', salary: 'ЗП: 60 тыс.', extra: '' },
	{ title: 'Работник в цех рубленных полуфабрикатов', salary: 'ЗП: от 60 тыс.', extra: '' },
	{ title: 'Продавец в фирменный магазин', salary: 'ЗП: от 50 тыс.', extra: '' },
	{ title: 'Экономист', salary: 'ЗП: от 60 тыс.', extra: '' },
	{ title: 'Повар в магазин', salary: 'ЗП: от 3 тыс. за смену', extra: '' },
	{ title: 'Мастер чистоты', salary: 'ЗП: 45 тыс.', extra: '' },
];

const PageVacancies = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { data, status } = useSelector(state => state.page.page);
	const mainInfo = useSelector(state => state.layout.mainInfo.data);
	const [modalVacancy, setModalVacancy] = useState(null);
	const [vacancies, setVacancies] = useState(DEFAULT_VACANCIES);
	const [commonText, setCommonText] = useState(DEFAULT_COMMON_TEXT);

	useEffect(() => {
		const vacanciesId = mainInfo?.top_menu?.vacancies?.id;
		if (vacanciesId) {
			dispatch(fetchPage({ id: vacanciesId }));
		}
	}, [dispatch, mainInfo]);

	useEffect(() => {
		fetcher('/index.php?route=information/vacancies')
			.then(res => (res && res.ok ? res.json() : null))
			.then(data => {
				if (!data) return;
				if (data.commonText) setCommonText(data.commonText);
				if (Array.isArray(data.vacancies) && data.vacancies.length > 0) {
					setVacancies(
						data.vacancies.map(v => ({
							title: v.title || '',
							salary: v.salary || '',
							extra: v.extra || '',
						}))
					);
				}
			})
			.catch(() => {});
	}, []);

	// Преимущества работы
	const benefits = [
		{
			icon: 'icon-benefit-comfort',
			title: 'Комфорт и Здоровье',
			text: 'На территории компании есть всё для вашего комфорта: разнообразное питание в столовой, медкабинет для оперативной помощи, уютная комната отдыха для релаксации и массажное кресло, чтобы снять напряжение.',
		},
		{
			icon: 'icon-benefit-rest',
			title: 'Отдых и Развлечения',
			text: 'В вашем распоряжении: настольный теннис для активного отдыха, а также шахматы для любителей спокойных игр. Насладитесь перерывом на нашей веранде с видом на цветочную клумбу, выпив чашку чая или кофе.',
		},
		{
			icon: 'icon-benefit-adventure',
			title: 'Сплочение и Приключения',
			text: 'Два раза в год мы организуем выездной корпоративный отдых на природе, куда вы можете отправиться вместе со своими родными и близкими! Это прекрасная возможность укрепить командный дух и отлично провести время.',
		},
	];

	return (
		<>
			<div className='region vacancies-section'>
				{/* Breadcrumb */}
				<div className='contact-breadcrumb' style={{ marginTop: '64px' }}>
					<a
						href='/'
						onClick={e => {
							e.preventDefault();
							navigate('/');
						}}
						className='breadcrumb-link'
					>
						Главная
					</a>
					<span className='breadcrumb-separator breadcrumb-separator-active'></span>
					<span className='breadcrumb-current'>Вакансии</span>
				</div>

				{/* Title */}
				<h1 className='vacancies-title'>ВАКАНСИИ</h1>

				{status === loadingStatus.SUCCEEDED && data ? (
					<>
						{/* Main content */}
						<div className='vacancies-content'>
							<div className='vacancies-description'>
								<p>
									Наша компания "РАЙЯН" - это прежде всего дружный, сплоченный,
									профессиональный коллектив единомышленников!
								</p>
								<p>
									Честность, добропорядочность, целеустремленность,
									ответственность, исполнительность, дисциплинированность,
									внимательность, пунктуальность,трудолюбие, коммуникабельность
									и доброжелательность - это ценности людей составляющих
									компанию.
								</p>
								<p>
									Именно таких людей мы приглашаем и рады видеть в нашей
									компании!
								</p>
							</div>
							<div className='vacancies-contacts'>
								<div className='vacancies-contacts-item'>
									<h4 className='vacancies-contacts-label'>
										Телефон для справок
									</h4>
									<a
										href='tel:+78866277-78-80'
										className='vacancies-contacts-value'
									>
										+7 (88662) 77-78-80
									</a>
									<a
										href='tel:+78662777880'
										className='vacancies-contacts-value'
									>
										+7 (866) 277-78-80
									</a>
								</div>
								<div className='vacancies-contacts-item'>
									<h4 className='vacancies-contacts-label'>Почта</h4>
									<a
										href='mailto:rayan07@bk.ru'
										className='vacancies-contacts-value'
									>
										rayan07@bk.ru
									</a>
								</div>
							</div>
						</div>

						{/* Benefits */}
						<div className='vacancies-benefits'>
							{benefits.map((benefit, index) => (
								<div key={index} className='vacancies-benefit-card'>
									<Icon
										name={benefit.icon}
										className='vacancies-benefit-icon'
									/>
									<h3 className='vacancies-benefit-title'>{benefit.title}</h3>
									<p className='vacancies-benefit-text'>{benefit.text}</p>
								</div>
							))}
						</div>

						{/* Vacancies list */}
						<div className='vacancies-list-section'>
							<h2 className='vacancies-list-title'>Все вакансии</h2>
							<div className='vacancies-grid'>
								{vacancies.map((vacancy, index) => (
									<button
										key={index}
										type='button'
										className='vacancy-button'
										onClick={() => setModalVacancy(vacancy)}
									>
										{vacancy.title}
									</button>
								))}
							</div>
						</div>
					</>
				) : status === loadingStatus.LOADING ? (
					<>
						<Skeleton
							active
							paragraph={{ rows: 4 }}
							style={{ marginBottom: '48px' }}
						/>
						<Skeleton
							active
							paragraph={{ rows: 6 }}
							style={{ marginBottom: '48px' }}
						/>
					</>
				) : (
					<div>Страница не найдена</div>
				)}
			</div>

			<Modal
				open={!!modalVacancy}
				title={modalVacancy?.title}
				onCancel={() => setModalVacancy(null)}
				footer={null}
				width={560}
			>
				{modalVacancy && (
					<div style={{ whiteSpace: 'pre-line', color: '#333' }}>
						<p style={{ marginBottom: 16, fontWeight: 600 }}>
							{modalVacancy.salary}
						</p>
						{modalVacancy.extra && (
							<p style={{ marginBottom: 16 }}>{modalVacancy.extra}</p>
						)}
						{commonText}
					</div>
				)}
			</Modal>

			{/* Quality Section */}
			{status === loadingStatus.SUCCEEDED && data && (
				<div
					className='region news-quality-section'
					style={{ marginBottom: '60px' }}
				>
					<h2 className='quality-title'>ДОВЕРЬТЕСЬ КАЧЕСТВУ</h2>
					<div className='quality-cards'>
						<div className='quality-card quality-card-gray'>
							<img
								src={`${process.env.PUBLIC_URL || ''}/images/icon-halal.webp`}
								alt=''
								className='quality-card-icon'
							/>
							<h4 className='quality-card-text'>
								Без свинины и ее компонентов
							</h4>
						</div>
						<div className='quality-card quality-card-gray'>
							<img
								src={`${process.env.PUBLIC_URL || ''}/images/icon-eggs.webp`}
								alt=''
								className='quality-card-icon'
							/>
							<h4 className='quality-card-text'>Натуральные молоко и яйцо</h4>
						</div>
						<div className='quality-card quality-card-gray'>
							<img
								src={`${process.env.PUBLIC_URL || ''}/images/icon-cow.webp`}
								alt=''
								className='quality-card-icon'
							/>
							<h4 className='quality-card-text'>Мясо собственного забоя</h4>
						</div>
						<div className='quality-card quality-card-gray'>
							<img
								src={`${process.env.PUBLIC_URL || ''}/images/icon-nature.webp`}
								alt=''
								className='quality-card-icon'
							/>
							<h4 className='quality-card-text'>
								Без консервантов и красителей
							</h4>
						</div>
						<div
							className='quality-card quality-card-blue'
							style={{
								backgroundImage: `url(${process.env.PUBLIC_URL || ''}/images/bg-quality-card.webp)`,
								backgroundSize: 'cover',
								backgroundPosition: 'center',
								backgroundRepeat: 'no-repeat',
							}}
						>
							<Icon name='icon-dna' className='quality-card-icon' />
							<h4 className='quality-card-text quality-card-text-white'>
								Без ГМО и заменителей мяса
							</h4>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default PageVacancies;
